import React from 'react';
import { BoxProps } from '../box';

export interface TranslateRange {
  min: number;
  max: number;
}

export interface DrawerSwipeInstance {
  startX: number;
  startY: number;
  scrollStartX: number;
  scrollStartY: number;
  velocity: number;
  lastTime: number | null;
  lastTranslate: number | null;
  baseTranslate: number;
  paperHit: boolean;
  isSwiping?: boolean | null;
}

export enum AssessmentState {
  None,
  LikeInProgress,
  DislikeInProgress,
}

export interface SwipeableCarouselWithAssessmentProps<ItemData> {
  itemsData: ItemData[];
  itemComponent: React.FC<{ data: ItemData; index: number; isOnTop: boolean }>;
  itemContainerProps?: BoxProps;
  swipingDisabled?: boolean;
  showInstruction?: boolean;
  onLike?: (parameters: { data: ItemData; index: number }) => void;
  onDislike?: (parameters: { data: ItemData; index: number }) => void;
  onInstructionCompleted?: () => void;
}
